<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dZOmKb/tc-custom/9781631592058.jpg?1726518932095" alt="This image is the cover for the book Quick Pickle Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quick Pickle Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <p>Make your own quick and delicious brines for pickling or cooking.The Quick Pickle Cookbook inspires creative uses for homemade vegetable and fruit pickles. Each pickled fruit or vegetable includes suggestions for creative uses in dishes and cocktails as well as flavor variations. You'll even learn how to use the brine in the recipes you prepare! Create tons of delicious recipes with pickled ingredients with The Quick Pickle Cookbook! Recipes include:   ·Killer Diller Pickles   ·Quick Kimchi   ·Bourbon-Pickled Blackberries   ·Lime-Chile Pickle Pineapple   ·And more!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Grace Parisi
      </h2>
      
      <p class="authorDescription body article">Grace Parisi is the author of 3 cookbooks, most recently, The Portlandia Cookbook; Cook Like a Local. Her previous book, Get Saucy was nominated for a James Beard award for Best Single Subject Book of 2005. She has since written for Cooking Light, Fitness, Epicurious, Health and O Magazine. In the kitchen Grace is adept at all cuisines and is an expert baker and recipe developer. Given the choice between sweet and savory, her response is always, "Yes, Please!" In her life outside the kitchen, Grace is a long distance runner, athlete, and an avid racer. She plays guitars, loves camping, gardening in her postage-stamp sized Brooklyn backyard and cooking for a crowd, including her husband and two children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Quarry Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28f88037